import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_red",
  "use": "icon-arrow_red-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-arrow_red\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h30v30H0z\" /><path fill=\"#FD5C60\" d=\"m16.465 15-6.188-6.188 1.768-1.767L20 15l-7.955 7.955-1.768-1.767z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol